import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'components/shared/AntComponent';
import { Button } from 'components/shared/ButtonComponent';

interface ChildProps {
    onLogout: () => void;
    warningDuration: number;
    timeout: number;
}

const SessionTimeout: React.FC<ChildProps> = ({
    timeout = 30 * 60 * 1000, // 30 minutes
    warningDuration = 5 * 60 * 1000, // 5 minutes
    onLogout,
}) => {
    const [showWarning, setShowWarning] = useState(false);
    const [countdown, setCountdown] = useState(warningDuration / 1000);

    const showWarningRef = useRef(false);
    const warningTimerRef = useRef<NodeJS.Timeout | null>(null);
    const logoutTimerRef = useRef<NodeJS.Timeout | null>(null);
    const countdownIntervalRef = useRef<NodeJS.Timeout | null>(null);

    // Keep ref updated with latest modal state
    useEffect(() => {
        showWarningRef.current = showWarning;
    }, [showWarning]);

    const resetTimers = () => {
        if (showWarningRef.current) return; // ❌ Do not reset if modal is shown

        clearAllTimers();

        warningTimerRef.current = setTimeout(() => {
            setShowWarning(true);
        }, timeout - warningDuration);
    };

    const clearAllTimers = () => {
        if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }
        setCountdown(warningDuration / 1000);
    };

    const handleStayLoggedIn = () => {
        setShowWarning(false);
        resetTimers();
    };

    const handleLogout = () => {
        clearAllTimers();
        onLogout();
    };

    const startCountdown = () => {
        countdownIntervalRef.current = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownIntervalRef.current!);
                    handleLogout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        // Also set logout timer in case something blocks the interval
        logoutTimerRef.current = setTimeout(() => {
            handleLogout();
        }, warningDuration);
    };

    // Start countdown when warning modal shows
    useEffect(() => {
        if (showWarning) {
            startCountdown();
        }
    }, [showWarning]);

    useEffect(() => {
        const activityEvents = ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'];
        const handleUserActivity = () => {
            if (!showWarningRef.current) {
                resetTimers();
            }
        };

        activityEvents.forEach((event) =>
            window.addEventListener(event, handleUserActivity)
        );

        resetTimers();

        return () => {
            activityEvents.forEach((event) =>
                window.removeEventListener(event, handleUserActivity)
            );
            clearAllTimers();
        };
    }, []);
    
    const formatTime = (totalSeconds: number) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes} mins ${seconds < 10 ? '0' : ''}${seconds} secs`;
    };

    return (
        <>
            {showWarning && (
                <Modal
                    title=""
                    open={showWarning}
                    maskClosable={false}
                    closable={false}
                    footer={null}
                >
                    <h5>Session Expiring</h5>
                    <p>Your session will expire in <strong>{formatTime(countdown)}</strong>.</p>
                    <Button type="primary" className='me-2' onClick={handleStayLoggedIn}>Stay Logged In</Button>
                    <Button onClick={handleLogout}>Logout Now</Button>
                </Modal>
            )}
        </>
    );
};

export default SessionTimeout;


// import React, { useEffect, useRef, useState } from 'react';
// import { Modal } from 'components/shared/AntComponent';
// import { Button } from 'components/shared/ButtonComponent';

// interface ChildProps {
//     onLogout: () => void;
//     warningDuration: number;
//     timeout: number;
// }

// const SessionTimeout: React.FC<ChildProps> = ({
//     timeout = 1 * 60 * 1000, // 15 minutes
//     warningDuration = 30 * 1000, // 1 minute
//     onLogout,
// }: {
//     timeout?: number;
//     warningDuration?: number;
//     onLogout: () => void;
// }) => {
//     const [showWarning, setShowWarning] = useState(false);
//     const [countdown, setCountdown] = useState(warningDuration / 1000);

//     const warningTimerRef = useRef<NodeJS.Timeout | null>(null);
//     const logoutTimerRef = useRef<NodeJS.Timeout | null>(null);
//     const countdownIntervalRef = useRef<NodeJS.Timeout | null>(null);

//     const resetTimers = () => {
//         if (!showWarning) {
//             clearAllTimers();
//         }


//         // Show warning modal before full timeout
//         warningTimerRef.current = setTimeout(() => {
//             setShowWarning(true);
//             startCountdown();

//             // Auto logout if no action during warning
//             logoutTimerRef.current = setTimeout(() => {
//                 handleLogout();
//             }, warningDuration);
//         }, timeout - warningDuration);
//     };

//     const clearAllTimers = () => {
//         if (showWarning === false) {
//             if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
//             if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
//             if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
//             setCountdown(warningDuration / 1000);
//         }
//     };

//     const handleStayLoggedIn = () => {
//         setShowWarning(false);
//         clearAllTimers();
//         resetTimers();

//     };

//     const handleLogout = () => {
//         setShowWarning(false);
//         clearAllTimers();
//         onLogout();
//     };

//     const startCountdown = () => {
//         countdownIntervalRef.current = setInterval(() => {
//             setCountdown((prev) => {
//                 if (prev <= 1) {
//                     clearInterval(countdownIntervalRef.current!);
//                     return 0;
//                 }
//                 return prev - 1;
//             });
//         }, 1000);
//     };

//     useEffect(() => {
//         const activityEvents = ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'];
//         const handleUserActivity = () => {
//             if (!showWarning) {
//                 resetTimers();
//             }

//         };

//         activityEvents.forEach((event) =>
//             window.addEventListener(event, handleUserActivity)
//         );

//         resetTimers(); // Start timers on mount

//         return () => {
//             activityEvents.forEach((event) =>
//                 window.removeEventListener(event, handleUserActivity)
//             );
//             clearAllTimers();
//         };
//     }, []);

//     const closeModal = () => {
//         setShowWarning(false);
//     }

//     const submitFuncs = () => {

//     }

//     return (
//         <>
//             {showWarning && (
//                 <Modal
//                     title="Associate Report Items"
//                     // confirmLoading={loading10}
//                     open={showWarning}
//                     maskClosable={false}
//                     onCancel={() => closeModal()}
//                     onOk={submitFuncs}
//                     footer={null}
//                 >
//                     <h2>Session Expiring</h2>
//                     <p>Your session will expire in <strong>{countdown}</strong> seconds.</p>
//                     <Button type="primary" onClick={handleStayLoggedIn}>Stay Logged In</Button>
//                     <Button onClick={handleLogout}>Logout Now</Button>
//                 </Modal>
//             )}
//         </>
//     );
// };

// export default SessionTimeout;




// // import React, { useEffect, useRef } from 'react';

// // interface ChildProps {
// //     onLogout: () => void;
// //     timeout: number;
// // }
// // const SessionTimeout: React.FC<ChildProps> = ({ onLogout, timeout = 900000 }) => {
// //     const timerRef = useRef<NodeJS.Timeout | null>(null);

// //     const resetTimer = () => {
// //         if (timerRef.current) clearTimeout(timerRef.current);
// //         timerRef.current = setTimeout(() => {
// //             onLogout();
// //         }, timeout);
// //     };

// //     useEffect(() => {
// //         // List of events that reset the timer
// //         const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

// //         events.forEach((event) => window.addEventListener(event, resetTimer));
// //         resetTimer(); // initialize timer on mount

// //         return () => {
// //             // Clean up on unmount
// //             events.forEach((event) => window.removeEventListener(event, resetTimer));
// //             if (timerRef.current) clearTimeout(timerRef.current);
// //         };
// //     }, []);

// //     return null;
// // };

// // export default SessionTimeout;
